import { call, put, takeLatest } from "redux-saga/effects";
import { getAccountDetailsFailure, getAccountDetailsStart, getAccountDetailsSuccess, getCompaniesFailure, getCompaniesStart, getCompaniesSuccess, getJobCountFailure, getJobCountStart, getJobCountSuccess, getProspectByEmailStart, getAllLeadsCountStart, getAllLeadsCountSuccess, getAllLeadsCountFailure, getPendingCompaniesSuccess, getPendingCompaniesFailure, getPendingCompaniesStart, getMyLeadsPendingCompaniesSuccess, getMyLeadsPendingCompaniesFailure, getMyLeadsPendingCompaniesStart } from "./accountDetailsSlice";
import { fetchAccountDetails, fetchCompanies, fetchProspectByEmail, getAccountCounts, fetchAllLeadsCount, fetchPendingCompanies } from "./accountDetailsAPi";


function* fetchAccountDetailsSaga(action) {
  try {
    const response = yield call(fetchAccountDetails, action.payload);
    const accountData = response?.data || [];
    // if (response.success) {
    //   yield put(getAccountDetailsSuccess(accountData));
    // } else {
    //   yield put(getAccountDetailsFailure("Invalid response format"));
    //   console.log("Failed to fetch account details");
    // }
    yield put(getAccountDetailsSuccess(accountData))
  } catch (error) {
    yield put(getAccountDetailsFailure(error.message));
    console.log(error.message || "Error fetching account details");
  }
}
function* fetchProspectSaga(action) {
  try {
    const response = yield call(fetchProspectByEmail, action.payload);
    if (response?.data?.[0]?.uiid) {
      const uiid = response.data[0].uiid;
      // once prospect found, recall jobs API
      yield put(getAccountDetailsStart({ modifiedBy: uiid }));
    } else {
      console.log("No prospect found with that email");
    }
  } catch (error) {
    console.log(error.message || "Error fetching prospect");
  }
}

function* fetchJobCountSaga(action) {
  try {
    const response = yield call(getAccountCounts, action.payload);
    const countsData = response?.data?.data?.[0] || {};
    // if (response?.success) {
    //   yield put(getJobCountSuccess(response.data.data[0]));
    // } else {
    //   yield put(getJobCountFailure("No metrics data found"));
    // }
    yield put(getJobCountSuccess(countsData));
  } catch (error) {
    yield put(getJobCountFailure(error.message));
  }
}

function* fetchAllLeadsCountSaga(action) {
  try {
    const response = yield call(fetchAllLeadsCount, action.payload);
    // let allLeadsCountData = response?.data || [];
    // console.log("allLeadsCountData",allLeadsCountData)
    let allLeadsCountData =
      response?.data?.data?.[0]?.stats || {};

    // console.log("allLeadsCountData", allLeadsCountData);

    yield put(getAllLeadsCountSuccess(allLeadsCountData));
  } catch (error) {
    yield put(getAllLeadsCountFailure(error.message));
  }
}

function* fetchCompaniesSaga(action) {
  try {
    const response = yield call(fetchCompanies, action.payload);
    let companiesData = response?.data || [];
    // if (response?.success) {
    //   yield put(getCompaniesSuccess(response.data));
    // } else {
    //   yield put(getCompaniesFailure("No companies found"));
    // }
    yield put(getCompaniesSuccess(companiesData));
  } catch (error) {
    yield put(getCompaniesFailure(error.message));
  }
}

function* fetchPendingCompaniesSaga(action) {
  try {
    const response = yield call(fetchPendingCompanies, action.payload);
    let companiesData = response?.data?.data || [];
    yield put(getPendingCompaniesSuccess(companiesData));
  } catch (error) {
    yield put(getPendingCompaniesFailure(error.message));
  }
}

function* fetchMyLeadsPendingCompaniesSaga(action) {
  try {
    const response = yield call(fetchPendingCompanies, action.payload);
    let companiesData = response?.data?.data || [];
    yield put(getMyLeadsPendingCompaniesSuccess(companiesData));
  } catch (error) {
    yield put(getMyLeadsPendingCompaniesFailure(error.message));
  }
}


export function* watchFetchAccountDetails() {
  yield takeLatest(getAccountDetailsStart.type, fetchAccountDetailsSaga);
  yield takeLatest(getProspectByEmailStart.type, fetchProspectSaga);
  yield takeLatest(getJobCountStart.type, fetchJobCountSaga);
  yield takeLatest(getCompaniesStart.type, fetchCompaniesSaga);
  yield takeLatest(getAllLeadsCountStart.type, fetchAllLeadsCountSaga);
  yield takeLatest(getPendingCompaniesStart.type, fetchPendingCompaniesSaga);
  yield takeLatest(getMyLeadsPendingCompaniesStart.type, fetchMyLeadsPendingCompaniesSaga);
}
